var getWebLevelFontSizes = function getWebLevelFontSizes(headingScale, level) {
  return headingScale[level - 1];
};
var getWebLevelBottomMargins = function getWebLevelBottomMargins(marginScale, level) {
  return marginScale[level - 1];
};

export { getWebLevelBottomMargins, getWebLevelFontSizes };
